import type { CreditsTier } from './types';

export const formatGrouped = (n: number): string => n.toLocaleString('en-IN');

// 5000 -> "5K", 2500 -> "2.5K" — matches the design's tick labels, which need
// to stay short enough that 7+ of them fit across the track.
export const formatShort = (n: number): string =>
  n >= 1000 ? `${(n / 1000).toFixed(n % 1000 ? 1 : 0)}K` : String(n);

export const perCreditPrice = (price: number, totalCredits: number): number =>
  totalCredits > 0 ? price / totalCredits : 0;

export const discountPct = (price: number, strikePrice?: number): number =>
  strikePrice && strikePrice > price
    ? Math.round((1 - price / strikePrice) * 100)
    : 0;

// Same index-to-percent math the slider itself uses for its thumb/marks, so
// ticks land exactly under their corresponding stop.
export const stepPct = (index: number, count: number): number =>
  count > 1 ? (index / (count - 1)) * 100 : 0;

// The candidate-facing (GetStoreItemsSub) and admin (AdminStoreItem) item
// types both carry these exact field names, so one mapper covers both
// consumers rather than duplicating the same five-field pluck in each.
export type CreditsSourceItem = {
  id?: string;
  sku_size?: number;
  bonus_sku_size?: number | null;
  gross_price_in_currency?: number;
  gross_price_in_currency_after_disc?: number;
  discount_pct_for_currency?: number;
};

export const itemToCreditsTier = (
  item: CreditsSourceItem,
): CreditsTier | undefined => {
  if (!item.id || !item.sku_size) return undefined;
  return {
    id: item.id,
    credits: item.sku_size,
    bonusCredits: item.bonus_sku_size ?? 0,
    price:
      item.gross_price_in_currency_after_disc ??
      item.gross_price_in_currency ??
      0,
    strikePrice: item.discount_pct_for_currency
      ? item.gross_price_in_currency
      : undefined,
  };
};
